import { Component, Input } from '@angular/core';
import {
  colorType,
  sizeType,
  avatarConfig,
  themeType,
  avatarType,
} from '@core/types/types';

@Component({
  selector: 'avatar-component',
  templateUrl: './avatar.component.html',
  imports: [],
  styleUrls: ['./avatar.component.scss'],
})
export class CustomAvatarComponent {
  @Input({ required: true }) config!: avatarConfig;

  protected avatarSizes: any = {
    sm: '40',
    md: '50',
    lg: '60',
  };

  protected defaultConfig = {
    type: 'label' as avatarType,
    theme: 'light' as themeType,
    color: 'primary' as colorType,
    size: 'sm' as sizeType,
  };

  protected contraryThemes = {
    dark: 'light',
    light: 'dark',
  };

  ngOnInit() {
    if (!this.config.size) this.config.size = this.defaultConfig.size;

    if (this.config.type == 'label') {
      if (!this.config.theme) this.config.theme = this.defaultConfig.theme;
      if (!this.config.color) this.config.color = this.defaultConfig.color;
    }
  }

  protected shortLabel(label: string) {
    if (label.length > 2) {
      let splittedLabel = label.split(' ');
      if (splittedLabel.length >= 3) {
        return (
          splittedLabel[0].charAt(0) + splittedLabel[2].charAt(0)
        ).toUpperCase();
      } else if (splittedLabel.length >= 2) {
        return (
          splittedLabel[0].charAt(0) + splittedLabel[1].charAt(0)
        ).toUpperCase();
      } else {
        return label.substring(0, 2);
      }
    } else {
      return label.toUpperCase();
    }
  }
}
